$(document).on('click','.active_currency',function(e){
  e.preventDefault();
  $('.currency_picker').slideToggle();
  $('li.currency_list').toggleClass('active')
});

$(document).on('click','.mob-arw-link',function(e){
  e.preventDefault();
  $(this).next('.mob-second-level').addClass('active');
});
$(document).on('click','.back-arrow',function(e){
  e.preventDefault();
  $(this).closest('.mob-second-level').removeClass('active');
});
$(document).on('click','.menu-burger,.menu-drawer-close',function (e) {
  e.preventDefault();
  $('body').toggleClass('menu-open');
  $('.search-open').removeClass('search-open');
});
$(document).on('click','.menu-drawer-close',function (e) {
  e.preventDefault();
  $('body').removeClass('menu-open');
  $('.mob-second-level').removeClass('active');
});
$(document).on('click','.header_weglot_btn',function(e){
  e.preventDefault();
  $(this).closest('.header_weglotcls').toggleClass('active');
});
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=8&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }
      $(".searchslider").flickity({
        autoPlay: false,
        cellAlign: 'left',
        groupCells: 4
        //freeScroll: true,
        //freeScrollFriction: 0.03
      });
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    $('.searchcls').addClass('searchdata');
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    $('.searchcls').removeClass('searchdata');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
$(document).on('click','.search-btn,.mob-search-btn,.search-close',function (e) {
  e.preventDefault();
  $('body').toggleClass('search-open');
  $('#Search').focus();
  $('body').removeClass('menu-open');
});
$(document).on('click','.overlay-box',function (e) {
  e.preventDefault();
  $('body').removeClass('search-open');
});
jQuery(document).on('keyup',function(evt) {
  if (evt.keyCode == 27) {
    $('body').removeClass('search-open');
  }
});
$('.mega-list').hover(function() {
   $('body').addClass('hover-nav');
}, function() {
   $('body').removeClass('hover-nav');
});
// const notificationbar = document.querySelector('.announcment-bar-outer-container');
// document.addEventListener('scroll', ()=>{
//   if(window.scrollY >= 537){
//     notificationbar.classList.add('announcement-bar-hide')
//   } else if(window.scrollY < 537){
//     notificationbar.classList.remove('announcement-bar-hide')

//   }
// })
$(window).on('scroll',function(e){
  const notificationbar = document.querySelector('.announcment-bar-outer-container')
  var scroll = $(window).scrollTop();
  var header_height = $('.header-group').height() + 100;
  // var window_height = (($(window).height()) - ($(window).height()/4));
  var window_height = (250);
  if(scroll >= window_height){
    $('body').addClass('default-header');
    if(notificationbar != null){
      notificationbar.classList.add('announcement-bar-hide');
  } 
  }else{
    $('body').removeClass('default-header');
    if(notificationbar != null){
      notificationbar.classList.remove('announcement-bar-hide');
    }
  }
});
$("body").on("click", function (e) {
  var seachbox = $(".snippet-search-bar,#predictive-search");
  if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0) {
    $("body").removeClass("search-open");
    $("#predictive-search").hide();
    $("#Search").val("");
  }
});

let wishlist_count = localStorage.getItem('th_wlc_pro_count');
if(wishlist_count > 0){
  let headerIcon = $('.header-right .th_wlc_position_relative');
  headerIcon.each(function() {
    $(this).addClass('active');
  });
}
